<template>
    <component class="d-inline-block loader" :class="{ 'loading': loading }" :is="element">
      <slot />
    </component>
</template>

<script>
export default {
  name: 'loader',
  props: {
    element: {
      type: String,
      default: 'span',
    },
    loading: Boolean,
  },
}
</script>
